import React from 'react';
import { Spinner } from 'reactstrap';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="d-flex justify-content-center align-items-center my-4">
      <Spinner color="primary" />
    </div>
  );
};

export default LoadingSpinner;
